// Stable identity for an alert, shared by the card list, the map, and the viewed-set.
// (serial, detection_date) uniquely identifies a detection.
export const alertKey = (a) => (a ? `${a.serial_number}::${a.detection_date}` : null)

export default alertKey
